import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { UserRole } from "../../actions/authentificationActions";
import { AppState } from "../../store/configureStore";
import { ExaminationOrganizationsView } from "./ExaminationOrganizationsView";
import { PaymentTypeView } from "./PaymentTypeView";
import "./AdminSettings.css";
import { AdminParameters } from "./AdminParameters";

export const AdminSettingsView = () => {
    const user = useSelector((state: AppState) => state.user);

    const examinationOrganizations = useSelector(
        (state: AppState) => state.examinationOrganizations
    );

    const paymentTypes = useSelector((state: AppState) => state.paymentTypes);

    return user.role !== UserRole.PowerUser ? (
        <Redirect to="/unauthorized" />
    ) : (
        <>
            <AdminParameters />
            <div className="admin-dashboard-container">
                <ExaminationOrganizationsView
                    examinationOrganizations={examinationOrganizations}
                    examinationCount={examinationOrganizations.length}
                />
                <PaymentTypeView
                    paymentTypes={paymentTypes}
                    paymentTypeCount={paymentTypes.length}
                />
            </div>
        </>
    );
};
